import type { FC } from "react";

import classNames from "classnames";
import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

import { translate } from "app/filters/i18nFilter";

import { UpgradeLink } from "./UpgradeLink";

const RegionFlagContainer = styled.div`
    display: flex;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-right: 7px;
`;

type RegionCellContentProps = { regionCode: number; text: string; className?: string };

const RegionCellContent: FC<RegionCellContentProps> = ({ regionCode, text, className }) => {
    return (
        <>
            <RegionFlagContainer className={classNames(className, "countryIcon-container")}>
                <SWReactIcons
                    size="xs"
                    iconName="location-circled"
                />
            </RegionFlagContainer>
            {regionCode === -1 ? (
                <UpgradeLink />
            ) : (
                <div
                    className="country-text"
                    title={text}
                >
                    {translate(`si.common.region.${text}.label`)}
                </div>
            )}
        </>
    );
};

export default RegionCellContent;
